import { render, staticRenderFns } from "./About.vue?vue&type=template&id=8f76f9e2&scoped=true&"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=8f76f9e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f76f9e2",
  null
  
)

export default component.exports